"use client"

import React, { Fragment, useState, useEffect } from "react"
import Breadcrumb from "../../layout/breadcrumb"
import { 
  Container, Row, Col, Card, CardHeader, CardBody, 
  Button, Badge, Spinner, Modal, ModalHeader, ModalBody,
  Nav, NavItem, NavLink
} from "reactstrap"
import { 
  FileText, Download, Play, Calendar, User, 
  CheckCircle, Clock, AlertCircle, Eye, X, Video, Image,
  Book, DollarSign, Minimize2, Maximize2, Filter, Home
} from "react-feather"
import authAxios from "../../services/Token"
import './Dashboard.css'
import Swal from 'sweetalert2'

const Default = () => {
  // Estados para noticias
  const [noticias, setNoticias] = useState([])
  const [noticiasFiltradas, setNoticiasFiltradas] = useState([])
  const [noticiasLoading, setNoticiasLoading] = useState(true)
  
  // Estados para documentos
  const [documentos, setDocumentos] = useState([])
  const [documentosLoading, setDocumentosLoading] = useState(true)
  const [estadisticas, setEstadisticas] = useState({
    pendientes: 0,
    aprobados: 0,
    total: 0
  })

  // Estados para categorías
  const [categorias, setCategorias] = useState([])
  const [categoriaActiva, setCategoriaActiva] = useState('todas')
  const [categoriasLoading, setCategoriasLoading] = useState(true)

  // Estados para modales
  const [modalVideo, setModalVideo] = useState(false)
  const [videoUrl, setVideoUrl] = useState('')
  const [modalDocumento, setModalDocumento] = useState(false)
  const [documentoSeleccionado, setDocumentoSeleccionado] = useState(null)
  const [modalImagen, setModalImagen] = useState(false)
  const [imagenUrl, setImagenUrl] = useState('')
  const [imagenTitulo, setImagenTitulo] = useState('')

  // Nuevos estados para modales de plataformas
  const [modalPlataforma, setModalPlataforma] = useState(false)
  const [plataformaUrl, setPlataformaUrl] = useState('')
  const [plataformaTitulo, setPlataformaTitulo] = useState('')
  const [modalFullscreen, setModalFullscreen] = useState(false)

  const [ventanaAbierta, setVentanaAbierta] = useState(false)
  const [plataformaActual, setPlataformaActual] = useState(null)
  
  // URL base del bucket S3
  const bucketUrl = 'https://documentos2024-aoa.s3.bhs.io.cloud.ovh.net/'

  // URLs de las plataformas externas
  const plataformas = {
    educativa: {
      url: 'https://personeriabqelearning.montierp.com/login',
      nombre: 'Plataforma Educativa',
      icono: Book,
      color: 'success'
    },
    contable: {
      url: 'https://barranquilla-personeria.softwarefinanciero.com/nominasa/siiafe.portal.secloginpub.aspx',
      nombre: 'Plataforma Siiafe',
      icono: DollarSign,
      color: 'info'
    }
  }

  // Cargar categorías
  const fetchCategorias = async () => {
    try {
      setCategoriasLoading(true)
      const response = await authAxios.get("cartelera/categorias")
      const categoriasData = response.data || []
      
      console.log('Categorías cargadas:', categoriasData)
      
      setCategorias(categoriasData)
    } catch (error) {
      console.error('Error al cargar categorías:', error)
      // Si hay error, crear categorías por defecto
      const categoriasDefault = [
        { id: 1, nombre: 'Noticias Generales', color: 'primary', icono: '📢', estado: 1 },
        { id: 2, nombre: 'Comunicados Internos', color: 'info', icono: '📋', estado: 1 },
        { id: 3, nombre: 'Eventos Corporativos', color: 'success', icono: '🎉', estado: 1 },
        { id: 4, nombre: 'Capacitaciones', color: 'warning', icono: '📚', estado: 1 },
        { id: 5, nombre: 'Anuncios Importantes', color: 'danger', icono: '⚠️', estado: 1 }
      ]
      setCategorias(categoriasDefault)
    } finally {
      setCategoriasLoading(false)
    }
  }

  // Cargar noticias
  const fetchNoticias = async () => {
    try {
      setNoticiasLoading(true)
      const response = await authAxios.get("cartelera/index")
      const noticiasData = response.data || []
      
      console.log('Noticias cargadas:', noticiasData)
      
      // Ordenar por fecha más reciente primero
      const noticiasOrdenadas = noticiasData.sort((a, b) => 
        new Date(b.fecha_inicial) - new Date(a.fecha_inicial)
      )
      
      setNoticias(noticiasOrdenadas)
      setNoticiasFiltradas(noticiasOrdenadas)
    } catch (error) {
      console.error('Error al cargar noticias:', error)
      Swal.fire("Error", "No se pudieron cargar las noticias", "error")
    } finally {
      setNoticiasLoading(false)
    }
  }

  // Cargar documentos
  const fetchDocumentos = async () => {
    try {
      setDocumentosLoading(true)
      const response = await authAxios.post("cartelera/documentos", {
        fecha_publicacion: new Date().toISOString().split('T')[0],
        publicado_por: localStorage.getItem("usuario_id") || 1
      })
      
      const documentosData = response.data || []
      setDocumentos(documentosData)

      // Calcular estadísticas
      const pendientes = documentosData.filter(doc => 
        doc.estado_aprobacion === 'sin_revisar'
      ).length
      const aprobados = documentosData.filter(doc => 
        doc.status === 'aprobado'
      ).length

      setEstadisticas({
        pendientes,
        aprobados,
        total: documentosData.length
      })
    } catch (error) {
      console.error('Error al cargar documentos:', error)
      Swal.fire("Error", "No se pudieron cargar los documentos", "error")
    } finally {
      setDocumentosLoading(false)
    }
  }

  useEffect(() => {
    fetchCategorias()
    fetchNoticias()
    fetchDocumentos()
  }, [])

  // Filtrar noticias por categoría
  useEffect(() => {
    if (categoriaActiva === 'todas') {
      setNoticiasFiltradas(noticias)
    } else {
      const filtradas = noticias.filter(noticia => 
        noticia.categoria == categoriaActiva
      )
      setNoticiasFiltradas(filtradas)
    }
  }, [categoriaActiva, noticias])

  // Función para obtener información de categoría
  const getCategoriaInfo = (categoriaId) => {
    console.log(categorias);
    console.log(categoriaId);
    const categoria = categorias.find(cat => cat.id == categoriaId)
    return categoria || { 
      nombre: 'Sin Categoría', 
      color: 'secondary', 
      icono: '📄' 
    }
  }

  // Función para abrir plataforma en modal
  const abrirPlataforma = (tipoPlataforma) => {
    const plataforma = plataformas[tipoPlataforma]
    if (plataforma) {
      // Configuración de la ventana emergente
      const width = 1300
      const height = 900
      const left = (window.screen.width - width) / 2
      const top = (window.screen.height - height) / 2
      
      const features = `
        width=${width},
        height=${height},
        left=${left},
        top=${top},
        menubar=no,
        toolbar=no,
        location=no,
        status=no,
        resizable=yes,
        scrollbars=yes,
        titlebar=no
      `.replace(/\s/g, '')
      
      // Abrir ventana emergente
      const nuevaVentana = window.open(
        plataforma.url, 
        `plataforma_${tipoPlataforma}`,
        features
      )
      
      if (nuevaVentana) {
        setPlataformaActual(plataforma)
        setVentanaAbierta(true)
        
        // Verificar si la ventana se cerró
        const verificarVentana = setInterval(() => {
          if (nuevaVentana.closed) {
            clearInterval(verificarVentana)
            setVentanaAbierta(false)
            setPlataformaActual(null)
          }
        }, 1000)
        
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Bloqueado por el navegador',
          text: 'Por favor, permite ventanas emergentes para este sitio',
          footer: 'Puedes hacer clic en el ícono de bloqueo en la barra de direcciones'
        })
      }
    }
  }

  // Función para alternar entre pantalla completa y normal
  const toggleFullscreen = () => {
    setModalFullscreen(!modalFullscreen)
  }

  // Función para cerrar modal de plataforma
  const cerrarModalPlataforma = () => {
    setModalPlataforma(false)
    setModalFullscreen(false)
    setTimeout(() => {
      setPlataformaUrl('')
      setPlataformaTitulo('')
    }, 300)
  }

  // Función para extraer ID de YouTube
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return ''
    
    try {
      const urlClean = url.trim()
      
      // Patrones de URLs de YouTube
      const patterns = [
        /youtu\.be\/([^#&?]{11})/,
        /youtube\.com\/watch\?v=([^#&?]{11})/,
        /youtube\.com\/embed\/([^#&?]{11})/,
        /youtube\.com\/v\/([^#&?]{11})/,
        /youtube\.com\/shorts\/([^#&?]{11})/
      ]
      
      let videoId = ''
      
      for (const pattern of patterns) {
        const match = urlClean.match(pattern)
        if (match) {
          videoId = match[1]
          break
        }
      }
      
      if (videoId && videoId.length === 11) {
        return `https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0&modestbranding=1&showinfo=0`
      }
      return ''
    } catch (error) {
      console.error('Error procesando URL de YouTube:', error)
      return ''
    }
  }

  // Función para verificar si es imagen
  const esImagen = (archivo) => {
    if (!archivo) return false
    const extensionesImagen = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp']
    return extensionesImagen.some(ext => archivo.toLowerCase().endsWith(ext))
  }

  // Función para obtener URL completa de archivo
  const getArchivoUrl = (archivo) => {
    if (!archivo) return ''
    return `${bucketUrl}${archivo}`
  }

  // Función para abrir video
  const abrirVideo = (url, titulo = "Video") => {
    const embedUrl = getYouTubeEmbedUrl(url)
    
    if (embedUrl) {
      setVideoUrl(embedUrl)
      setModalVideo(true)
    } else {
      Swal.fire({
        icon: 'error',
        title: 'URL de video no válida',
        text: 'No se pudo procesar la URL del video de YouTube.',
        footer: `URL proporcionada: ${url}`
      })
    }
  }

  // Función para abrir imagen en modal
  const abrirImagen = (archivo, titulo = "Imagen") => {
    const urlCompleta = getArchivoUrl(archivo)
    setImagenUrl(urlCompleta)
    setImagenTitulo(titulo)
    setModalImagen(true)
  }

  // Función para cerrar modal de video
  const cerrarModalVideo = () => {
    setModalVideo(false)
    setTimeout(() => setVideoUrl(''), 300)
  }

  // Función para cerrar modal de imagen
  const cerrarModalImagen = () => {
    setModalImagen(false)
    setTimeout(() => {
      setImagenUrl('')
      setImagenTitulo('')
    }, 300)
  }

  // Función para abrir documento
  const abrirDocumento = (documento) => {
    setDocumentoSeleccionado(documento)
    setModalDocumento(true)
  }

  // Función para cerrar modal de documento
  const cerrarModalDocumento = () => {
    setModalDocumento(false)
    setDocumentoSeleccionado(null)
  }

  // Función para descargar archivo desde URL directa
  const descargarArchivo = (archivo, nombre) => {
    try {
      const urlCompleta = getArchivoUrl(archivo)
      
      // Crear enlace temporal para descarga
      const link = document.createElement('a')
      link.href = urlCompleta
      link.setAttribute('download', nombre || 'documento.pdf')
      link.setAttribute('target', '_blank')
      link.setAttribute('rel', 'noopener noreferrer')
      
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      Swal.fire("Éxito", "Descarga iniciada", "success")
      
    } catch (error) {
      console.error('Error al descargar archivo:', error)
      Swal.fire("Error", "No se pudo descargar el archivo", "error")
    }
  }

  // Función para ver archivo en nueva pestaña
  const verArchivo = (archivo) => {
    try {
      const urlCompleta = getArchivoUrl(archivo)
      window.open(urlCompleta, '_blank', 'noopener,noreferrer')
    } catch (error) {
      console.error('Error al abrir archivo:', error)
      Swal.fire("Error", "No se pudo abrir el archivo", "error")
    }
  }

  // Formatear fecha
 const formatFecha = (fecha) => {
  if (!fecha) return ''
  
  try {
    // Dividir la fecha manualmente para evitar la conversión automática
    const [year, month, day] = fecha.split('T')[0].split('-').map(Number)
    
    // Crear objeto de fecha con Intl.DateTimeFormat para tener más control
    const fechaFormateada = new Intl.DateTimeFormat('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'America/Bogota' // Forzar Colombia
    }).format(new Date(year, month - 1, day)) // Restar 1 al mes porque en JS empieza en 0
    
    return fechaFormateada
    
  } catch (error) {
    console.error('Error formateando fecha:', error)
    return fecha
  }
}

  // Obtener estado del documento
  const getEstadoDocumento = (documento) => {
    if (documento.estado_aprobado === 1) return { texto: "Aprobado", color: "success" }
    if (documento.estado_aprobacion === 'PENDIENTE POR APROBACION') return { texto: "Pendiente", color: "warning" }
    if (documento.estado === 0) return { texto: "Inactivo", color: "secondary" }
    return { texto: "Desconocido", color: "secondary" }
  }

  // Componente de thumbnail de video
  const VideoThumbnail = ({ url, titulo, onClick }) => {
    const videoId = getYouTubeEmbedUrl(url).split('/embed/')[1]?.split('?')[0]
    const thumbnailUrl = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : ''
    
    return (
      <div className="video-thumbnail-container" onClick={onClick}>
        {thumbnailUrl ? (
          <>
            <img 
              src={thumbnailUrl} 
              alt={`Miniatura de ${titulo}`}
              className="video-thumbnail"
            />
            <div className="video-play-overlay">
              <Play size={48} className="play-icon" />
            </div>
          </>
        ) : (
          <div className="video-placeholder">
            <Video size={48} className="text-muted" />
            <span>Video no disponible</span>
          </div>
        )}
      </div>
    )
  }

  // Componente de botón de plataforma
  const BotonPlataforma = ({ tipo }) => {
    const plataforma = plataformas[tipo]
    const Icono = plataforma.icono
    
    return (
      <Col md="6" className="mb-3">
        <Card className="h-100 shadow-sm border-0 platform-card">
          <CardBody className="text-center p-4">
            <div className={`platform-icon mb-3 bg-${plataforma.color}-light`}>
              <Icono size={32} className={`text-${plataforma.color}`} />
            </div>
            <h5 className="platform-title">{plataforma.nombre}</h5>
            <p className="text-muted small mb-3">
              Acceso directo a la plataforma {plataforma.nombre.toLowerCase()}
            </p>
            <Button 
              color={plataforma.color}
              className="w-100"
              onClick={() => abrirPlataforma(tipo)}
            >
              <Icono size={16} className="me-2" />
              Ingresar
            </Button>
          </CardBody>
        </Card>
      </Col>
    )
  }

  // Componente de navegación de categorías
  const NavegacionCategorias = () => {
    if (categoriasLoading) {
      return (
        <div className="text-center py-3">
          <Spinner size="sm" color="primary" />
          <span className="ms-2">Cargando categorías...</span>
        </div>
      )
    }

    return (
      <Card className="mb-4 shadow-sm border-0">
        <CardHeader className="bg-light text-dark">
          <h6 className="mb-0 d-flex align-items-center">
            <Filter size={18} className="me-2" />
            FILTRAR POR CATEGORÍA..
          </h6>
        </CardHeader>
        <CardBody className="p-3">
          <Nav pills className="flex-wrap categoria-nav">
            <NavItem>
              <NavLink 
                active={categoriaActiva === 'todas'} 
                onClick={() => setCategoriaActiva('todas')}
                className="cursor-pointer me-2 mb-2"
              >
                <Home size={14} className="me-1" />
                Todas las Noticias
                <Badge color="light" className="text-dark ms-1">
                  {noticias.length}
                </Badge>
              </NavLink>
            </NavItem>
            {categorias.map(categoria => (
              <NavItem key={categoria.id}>
                <NavLink 
                  active={categoriaActiva == categoria.id} 
                  onClick={() => setCategoriaActiva(categoria.id)}
                  className={`cursor-pointer me-2 mb-2 text-${categoria.color}`}
                >
                  <span className="me-1">{categoria.icono}</span>
                  {categoria.nombre}
                  <Badge color={categoria.color} className="ms-1">
                    {noticias.filter(n => n.categoria == categoria.id).length}
                  </Badge>
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </CardBody>
      </Card>
    )
  }

  // Componente de noticia tipo periódico MEJORADO
  const NoticiaPeriodico = ({ noticia, index }) => {
    const tieneVideo = noticia.url_video && noticia.url_video.trim() !== ''
    const tieneArchivo = noticia.archivo && noticia.archivo.trim() !== ''
    const esImagenArchivo = esImagen(noticia.archivo)
    const esDestacada = index === 0
    const categoriaInfo = getCategoriaInfo(noticia.categoria)

    if (esDestacada) {
      return (
        <Card className="noticia-destacada mb-5 shadow-lg border-0">
          <CardBody className="p-4">
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div>
                <Badge 
                  color={categoriaInfo.color} 
                  className="fs-6 px-3 py-2 mb-2"
                >
                  {categoriaInfo.icono} {categoriaInfo.nombre}
                </Badge>
                <Badge 
                  color={noticia.estado === 1 ? "success" : "secondary"} 
                  className="fs-6 px-3 py-2 ms-2"
                >
                  {noticia.estado === 1 ? "📰 NOTICIA DESTACADA" : "INACTIVA"}
                </Badge>
              </div>
              <div className="text-muted">
                <Calendar size={16} className="me-1" />
                {formatFecha(noticia.fecha_inicial)}
              </div>
            </div>

            {noticia.titulo && (
              <h4 className="noticia-subtitulo mb-2 text-warning">
                {noticia.titulo}
              </h4>
            )}

            <div 
              className="noticia-titulo-destacado mb-3 text-primary texto-con-saltos"
              dangerouslySetInnerHTML={{ __html: noticia.descripcion }}
            />

            {/* Contenido multimedia - DISEÑO MEJORADO */}
            <div className="multimedia-container mb-4">
              {tieneVideo && (
                <div className="video-section mb-3">
                  <VideoThumbnail 
                    url={noticia.url_video}
                    titulo={noticia.descripcion}
                    onClick={() => abrirVideo(noticia.url_video, noticia.descripcion)}
                  />
                </div>
              )}

              {tieneArchivo && esImagenArchivo && (
                <div className="imagen-section mb-3">
                  <div className="imagen-destacada-container">
                    <img 
                      src={getArchivoUrl(noticia.archivo)}
                      alt={noticia.descripcion}
                      className="imagen-destacada cursor-pointer"
                      onClick={() => abrirImagen(noticia.archivo, noticia.descripcion)}
                      onError={(e) => {
                        e.target.style.display = 'none'
                        e.target.nextSibling.style.display = 'block'
                      }}
                    />
                    <div className="imagen-placeholder" style={{display: 'none'}}>
                      <Image size={48} className="text-muted" />
                      <span>Imagen no disponible</span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="noticia-meta mb-4">
              <div className="d-flex align-items-center text-muted mb-2">
                <User size={16} className="me-2" />
                <span>Publicado por: Usuario {noticia.publicado_por}</span>
              </div>
              <div className="text-muted">
                <Clock size={16} className="me-2" />
                <span>Vence: {formatFecha(noticia.fecha_vencimiento)}</span>
              </div>
            </div>

            <div className="acciones-container d-flex gap-2 flex-wrap">
              {tieneVideo && (
                <Button
                  color="danger"
                  className="d-flex align-items-center"
                  onClick={() => abrirVideo(noticia.url_video, noticia.descripcion)}
                >
                  <Play size={14} className="me-1" />
                  Ver Video
                </Button>
              )}

              {tieneArchivo && esImagenArchivo && (
                <Button
                  color="info"
                  className="d-flex align-items-center"
                  onClick={() => abrirImagen(noticia.archivo, noticia.descripcion)}
                >
                  <Image size={14} className="me-1" />
                  Ver Imagen
                </Button>
              )}

              {tieneArchivo && !esImagenArchivo && (
                <Button
                  color="outline-primary"
                  className="d-flex align-items-center"
                  onClick={() => descargarArchivo(noticia.archivo, noticia.descripcion)}
                >
                  <Download size={14} className="me-1" />
                  Descargar Documento
                </Button>
              )}
            </div>
          </CardBody>
        </Card>
      )
    }

    // Noticias normales (grid) - DISEÑO MEJORADO
    return (
      <Col lg="6" md="6" sm="12" className="mb-4">
        <Card className="noticia-normal h-100 shadow-sm border-0">
          <CardBody className="p-3">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <Badge 
                color={categoriaInfo.color} 
                size="sm"
                className="categoria-badge"
              >
                {categoriaInfo.icono} {categoriaInfo.nombre}
              </Badge>
              <small className="text-muted">
                <Calendar size={12} className="me-1" />
                {formatFecha(noticia.fecha_inicial)}
              </small>
            </div>

            {noticia.titulo && (
              <h6 className="noticia-subtitulo-small mb-1 text-warning">
                {noticia.titulo}
              </h6>
            )}

            <div 
              className="noticia-titulo mb-2 text-dark"
              dangerouslySetInnerHTML={{ __html: noticia.descripcion }}
            />

            {/* Contenido multimedia para noticias normales */}
            <div className="multimedia-container-small mb-2">
              {tieneVideo && (
                <div className="video-thumbnail-small mb-2">
                  <VideoThumbnail 
                    url={noticia.url_video}
                    titulo={noticia.descripcion}
                    onClick={() => abrirVideo(noticia.url_video, noticia.descripcion)}
                  />
                </div>
              )}

              {tieneArchivo && esImagenArchivo && (
                <div className="imagen-small-container mb-2">
                  <img 
                    src={getArchivoUrl(noticia.archivo)}
                    alt={noticia.descripcion}
                    className="imagen-small cursor-pointer"
                    onClick={() => abrirImagen(noticia.archivo, noticia.descripcion)}
                    onError={(e) => {
                      e.target.style.display = 'none'
                    }}
                  />
                </div>
              )}
            </div>

            <div className="noticia-meta">
              <small className="text-muted d-block mb-1">
                <User size={12} className="me-1" />
                Por: Usuario {noticia.publicado_por}
              </small>
              <small className="text-muted">
                <Clock size={12} className="me-1" />
                Vence: {formatFecha(noticia.fecha_vencimiento)}
              </small>
            </div>

            <div className="acciones-container-small d-flex gap-1 mt-2 flex-wrap">
              {tieneVideo && (
                <Button
                  color="outline-danger"
                  size="sm"
                  className="d-flex align-items-center"
                  onClick={() => abrirVideo(noticia.url_video, noticia.descripcion)}
                >
                  <Play size={12} className="me-1" />
                  Video
                </Button>
              )}

              {tieneArchivo && esImagenArchivo && (
                <Button
                  color="outline-info"
                  size="sm"
                  className="d-flex align-items-center"
                  onClick={() => abrirImagen(noticia.archivo, noticia.descripcion)}
                >
                  <Image size={12} className="me-1" />
                  Imagen
                </Button>
              )}

              {tieneArchivo && !esImagenArchivo && (
                <Button
                  color="outline-primary"
                  size="sm"
                  className="d-flex align-items-center"
                  onClick={() => descargarArchivo(noticia.archivo, noticia.descripcion)}
                >
                  <Download size={12} className="me-1" />
                  Descargar
                </Button>
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    )
  }

  // Componente de documento
  const DocumentoCard = ({ documento }) => {
    const estado = getEstadoDocumento(documento)
    
    return (
      <Card className="documento-card mb-3 shadow-sm border-0">
        <CardBody className="p-3">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div className="d-flex align-items-center">
              <FileText size={16} className="text-primary me-2" />
              <h6 className="mb-0 documento-titulo">{documento.name}</h6>
            </div>
            <Badge color={estado.color} size="sm">
              {documento.status}
            </Badge>
          </div>
          
          <div 
            className="documento-descripcion text-muted small mb-2"
            dangerouslySetInnerHTML={{ __html: documento.description }}
          />
          
          <div className="documento-meta mb-3">
            <small className="text-muted d-block">
              <Calendar size={12} className="me-1" />
              Fecha: {documento.approval_date}
            </small>
            {documento.aprobador && (
              <small className="text-muted">
                <User size={12} className="me-1" />
                Aprobado por: {documento.aprobador}
              </small>
            )}
          </div>
          
          <div className="documento-acciones d-flex gap-2">
            <Button
              color="outline-primary"
              size="sm"
              className="d-flex align-items-center"
              onClick={() => verArchivo(documento.file_path)}
            >
              <Eye size={12} className="me-1" />
              Ver
            </Button>
            <Button
              color="primary"
              size="sm"
              className="d-flex align-items-center"
              onClick={() => descargarArchivo(documento.file_path, documento.name)}
            >
              <Download size={12} className="me-1" />
              Descargar
            </Button>
          </div>
        </CardBody>
      </Card>
    )
  }

  return (
    <Fragment>
      <Breadcrumb parent="Cartelera" title="Noticias y Documentos" />
      <Container fluid={true}>
        
        {/* Nueva Sección: Accesos Directos a Plataformas */}
        <Row className="mb-4">
          <Col xl="12">
            <Card className="shadow border-0">
              <CardHeader className="bg-gradient-primary text-white">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-0 fw-bold">
                    🚀 ACCESOS DIRECTOS
                  </h4>
                  <Badge color="light" className="text-dark fs-6">
                    PLATAFORMAS EXTERNAS
                  </Badge>
                </div>
              </CardHeader>
              <CardBody className="p-4">
                <Row>
                  <BotonPlataforma tipo="educativa" />
                  <BotonPlataforma tipo="contable" />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Mapa de Navegación de Categorías */}
        <NavegacionCategorias />

        {/* Sección Principal */}
        <Row>
          {/* Sección de Noticias - Diseño Periódico MEJORADO */}
          <Col xl="8" lg="7" md="12" className="mb-4">
            <Card className="shadow border-0">
              <CardHeader className="bg-primary text-white">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-0 fw-bold">
                    📰 CARTELERA CORPORATIVA
                    {categoriaActiva !== 'todas' && (
                      <Badge color="light" className="ms-2 text-dark">
                        {getCategoriaInfo(categoriaActiva).nombre}
                      </Badge>
                    )}
                  </h4>
                  <div>
                    <Badge color="light" className="text-dark fs-6 me-2">
                      {noticiasFiltradas.length} NOTICIAS
                    </Badge>
                    {categoriaActiva !== 'todas' && (
                      <Button 
                        color="light" 
                        size="sm"
                        onClick={() => setCategoriaActiva('todas')}
                      >
                        <Home size={14} className="me-1" />
                        Ver Todas
                      </Button>
                    )}
                  </div>
                </div>
              </CardHeader>
              <CardBody className="p-4">
                {noticiasLoading ? (
                  <div className="text-center py-5">
                    <Spinner color="primary" />
                    <p className="mt-2 text-muted">Cargando noticias...</p>
                  </div>
                ) : noticiasFiltradas.length > 0 ? (
                  <div className="periodico-container">
                    {/* Noticia destacada */}
                    {noticiasFiltradas.length > 0 && <NoticiaPeriodico noticia={noticiasFiltradas[0]} index={0} />}
                    
                    {/* Grid de noticias secundarias */}
                    {noticiasFiltradas.length > 1 && (
                      <>
                        <hr className="my-5" />
                        <h5 className="mb-4 text-muted">MÁS NOTICIAS {categoriaActiva !== 'todas' ? `EN ${getCategoriaInfo(categoriaActiva).nombre.toUpperCase()}` : ''}</h5>
                        <Row>
                          {noticiasFiltradas.slice(1).map((noticia, index) => (
                            <NoticiaPeriodico 
                              key={noticia.id} 
                              noticia={noticia} 
                              index={index + 1} 
                            />
                          ))}
                        </Row>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <FileText size={48} className="text-muted mb-3" />
                    <h5 className="text-muted">
                      {categoriaActiva === 'todas' 
                        ? 'No hay noticias disponibles' 
                        : `No hay noticias en ${getCategoriaInfo(categoriaActiva).nombre}`
                      }
                    </h5>
                    <p className="text-muted">
                      {categoriaActiva === 'todas' 
                        ? 'No se encontraron noticias para mostrar.' 
                        : 'Intenta con otra categoría o vuelve a ver todas las noticias.'
                      }
                    </p>
                    {categoriaActiva !== 'todas' && (
                      <Button 
                        color="primary"
                        onClick={() => setCategoriaActiva('todas')}
                      >
                        <Home size={14} className="me-1" />
                        Ver Todas las Noticias
                      </Button>
                    )}
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

          {/* Sección de Documentos */}
          <Col xl="4" lg="5" md="12">
            <Card className="shadow border-0 h-100">
              <CardHeader className="bg-info text-white">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-0 fw-bold">
                    📄 ULTIMOS DOCUMENTOS
                  </h4>
                  <Badge color="light" className="text-dark fs-6">
                    {documentos.length} DOCS
                  </Badge>
                </div>
              </CardHeader>
              <CardBody className="p-3">
                {documentosLoading ? (
                  <div className="text-center py-4">
                    <Spinner color="info" />
                    <p className="mt-2 text-muted">Cargando documentos...</p>
                  </div>
                ) : documentos.length > 0 ? (
                  <div className="documentos-container">
                    {/* Estadísticas */}
                    <div className="estadisticas-documentos mb-4 p-3 bg-light  text-dark rounded">
                      <Row className="text-center">
                        <Col md="4">
                          <div className="estadistica-item">
                            <div className="estadistica-numero text-primary fw-bold fs-4">
                              {estadisticas.total}
                            </div>
                            <div className="estadistica-label text-muted small">
                              Total
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="estadistica-item">
                            <div className="estadistica-numero text-success fw-bold fs-4">
                              {estadisticas.aprobados}
                            </div>
                            <div className="estadistica-label text-muted small">
                              Aprobados
                            </div>
                          </div>
                        </Col>
                        <Col md="4">
                          <div className="estadistica-item">
                            <div className="estadistica-numero text-warning fw-bold fs-4">
                              {estadisticas.pendientes}
                            </div>
                            <div className="estadistica-label text-muted small">
                              Pendientes
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    {/* Lista de documentos */}
                    <div className="documentos-lista">
                      {documentos.map(documento => (
                        <DocumentoCard 
                          key={documento.id} 
                          documento={documento} 
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <FileText size={48} className="text-muted mb-3" />
                    <h5 className="text-muted">No hay documentos disponibles</h5>
                    <p className="text-muted">No se encontraron documentos para mostrar.</p>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal de Plataforma Externa */}
        <Modal 
          isOpen={modalPlataforma} 
          toggle={cerrarModalPlataforma} 
          size={modalFullscreen ? "xl" : "lg"}
          fullscreen={modalFullscreen}
          centered
          onClosed={() => {
            setPlataformaUrl('')
            setPlataformaTitulo('')
            setModalFullscreen(false)
          }}
        >
          <ModalHeader toggle={cerrarModalPlataforma} className="border-bottom-0 pb-0 d-flex align-items-center">
            <h5 className="modal-title mb-0 d-flex align-items-center">
              {plataformaTitulo}
              <Badge color="primary" className="ms-2">
                {modalFullscreen ? 'Pantalla Completa' : 'Normal'}
              </Badge>
            </h5>
            <div className="d-flex align-items-center ms-auto">
              <Button
                color="link"
                className="p-0 me-2"
                onClick={toggleFullscreen}
                title={modalFullscreen ? 'Minimizar' : 'Pantalla completa'}
              >
                {modalFullscreen ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
              </Button>
              <Button
                color="link"
                className="p-0"
                onClick={cerrarModalPlataforma}
                style={{ lineHeight: 1 }}
              >
                <X size={20} />
              </Button>
            </div>
          </ModalHeader>
          <ModalBody className="p-0" style={{ height: modalFullscreen ? 'calc(100vh - 80px)' : '70vh' }}>
            {plataformaUrl ? (
              <iframe
                src={plataformaUrl}
                title={plataformaTitulo}
                style={{ 
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: '0 0 8px 8px'
                }}
                allow="fullscreen"
                key={plataformaUrl}
              />
            ) : (
              <div className="text-center py-5">
                <Spinner color="primary" />
                <p className="mt-2 text-muted">Cargando plataforma...</p>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Modal de Video */}
        <Modal 
          isOpen={modalVideo} 
          toggle={cerrarModalVideo} 
          size="lg" 
          centered
          onClosed={() => setVideoUrl('')}
        >
          <ModalHeader toggle={cerrarModalVideo} className="border-bottom-0 pb-0 d-flex align-items-center">
            <h5 className="modal-title mb-0">Reproduciendo Video</h5>
            <Button
              color="link"
              className="p-0 ms-auto"
              onClick={cerrarModalVideo}
              style={{ lineHeight: 1 }}
            >
              <X size={20} />
            </Button>
          </ModalHeader>
          <ModalBody className="pt-0">
            {videoUrl ? (
              <div className="ratio ratio-16x9">
                <iframe
                  src={videoUrl}
                  title="Video corporativo"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ 
                    border: 'none', 
                    borderRadius: '8px',
                    width: '100%',
                    height: '100%'
                  }}
                  key={videoUrl}
                />
              </div>
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">Cargando video...</p>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Modal de Imagen */}
        <Modal 
          isOpen={modalImagen} 
          toggle={cerrarModalImagen} 
          size="lg" 
          centered
          onClosed={() => {
            setImagenUrl('')
            setImagenTitulo('')
          }}
        >
          <ModalHeader toggle={cerrarModalImagen} className="border-bottom-0 pb-0 d-flex align-items-center">
            <h5 className="modal-title mb-0">{imagenTitulo}</h5>
            <Button
              color="link"
              className="p-0 ms-auto"
              onClick={cerrarModalImagen}
              style={{ lineHeight: 1 }}
            >
              <X size={20} />
            </Button>
          </ModalHeader>
          <ModalBody className="pt-0">
            {imagenUrl ? (
              <div className="text-center">
                <img 
                  src={imagenUrl} 
                  alt={imagenTitulo}
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: '70vh',
                    borderRadius: '8px'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none'
                  }}
                />
              </div>
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">Cargando imagen...</p>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Modal para Documento */}
        <Modal isOpen={modalDocumento} toggle={cerrarModalDocumento} size="lg">
          <ModalHeader toggle={cerrarModalDocumento}>
            <div className="d-flex align-items-center">
              <FileText size={20} className="text-primary me-2" />
              <span>{documentoSeleccionado?.nombre}</span>
            </div>
          </ModalHeader>
          <ModalBody>
            {documentoSeleccionado && (
              <div>
                <div className="mb-3">
                  <h6>Descripción:</h6>
                  <div 
                    className="text-muted"
                    dangerouslySetInnerHTML={{ __html: documentoSeleccionado.descripcion }}
                  />
                </div>
                
                <div className="row mb-3">
                  <div className="col-md-6">
                    <small className="text-muted d-block">
                      <Calendar size={14} className="me-1" />
                      Fecha de vigencia: {formatFecha(documentoSeleccionado.fecha_vigencia)}
                    </small>
                  </div>
                  <div className="col-md-6">
                    <small className="text-muted d-block">
                      <User size={14} className="me-1" />
                      Aprobado por: {documentoSeleccionado.aprobador || 'No asignado'}
                    </small>
                  </div>
                </div>
                
                <div className="mb-3">
                  <Badge color={getEstadoDocumento(documentoSeleccionado).color}>
                    Estado: {getEstadoDocumento(documentoSeleccionado).texto}
                  </Badge>
                </div>
                
                <div className="d-flex gap-2">
                  <Button
                    color="primary"
                    className="d-flex align-items-center"
                    onClick={() => verArchivo(documentoSeleccionado.archivo)}
                  >
                    <Eye size={16} className="me-1" />
                    Ver Documento
                  </Button>
                  <Button
                    color="success"
                    className="d-flex align-items-center"
                    onClick={() => descargarArchivo(documentoSeleccionado.archivo, documentoSeleccionado.nombre)}
                  >
                    <Download size={16} className="me-1" />
                    Descargar
                  </Button>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      </Container>
    </Fragment>
  )
}

export default Default